import {Icustomer} from 'hec/types/common'
export const mockCustomerData: Icustomer = {
    email: 'rgoh@pixelmedia.com',
    isGuest: false,
    isRegistered: true,
    c_acLoyaltyTier: 'Gold'
}
